import { z } from 'zod';

export const teamSchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
});

export const teamDisplaySchema = teamSchema;

export type TeamDTO = z.infer<typeof teamSchema>;
export type TeamDisplayDTO = z.infer<typeof teamDisplaySchema>;
